<template>
  <template-info :bgImg="bgImg" title="แบบฟอร์มแต่ละแบบคืออะไร">
    <div>
      <span class="bold">คำร้อง ล.ป.10.1</span>
      <div>
        แบบคําร้องขอมีเลขและบัตรประจําตัวผู้เสียภาษีอากร/แก้ไขรายละเอียดผู้เสียภาษีประเภทบุคคลธรรมดา
        ใช้สําหรับกรณีที่ผู้ยื่นคําร้องเป็นบุคคลธรรมดา
      </div>
      <br />
      <span class="bold">คำร้อง ล.ป.10.2</span>
      <div>
        แบบคําร้องขอมีเลขและบัตรประจําตัวผู้เสียภาษีอากร/แก้ไขรายละเอียดผู้เสียภาษีประเภทคณะบุคคลหรือห้างหุ้นส่วนสามัญใช้สำหรับกรณีที่ผู้ยื่นคำร้องเป็น
        คณะบุคคล
      </div>
      <br />
      <span class="bold">แบบแจ้งรายได้พนักงานรอบรายปี ภ.ง.ด. 1ก</span>
      <div>
        ใบสรุปการจ่ายเงินเดือน ค่าจ้าง เบี้ยเลี้ยง โบนัส
        สวัสดิการอื่นที่จ่ายให้กับพนักงาน (เช่น ค่าเช่า) ภาษีที่นายจ้างออกแทนให้
        และภาษีของพนักงาน รอบรายปี ซึ่งเจ้าของธุรกิจจะต้องทำส่งเพื่อแจ้ง
        ให้กรมสรรพากร
      </div>
      <br />
      <span class="bold">แบบแจ้งรายได้พนักงาน ภ.ง.ด. 1</span>
      <div>
        ใช้สำหรับแจ้งพนักงานที่มีรายได้ถึงฐานที่ต้องเสียภาษีแล้วเท่านั้น
        และต้องทำส่งกรมสรรพากรทุกเดือน ภายในวันที่ 7 ของเดือนถัดไปทุกเดือน
      </div>
      <br />
      <span class="bold">แบบแจ้งภาษีหัก ณ ที่จ่าย ภ.ง.ด. 3</span>
      <div>
        แบบยื่นภาษีเงินได้หัก ณ ที่จ่าย ที่ผู้จ่ายเป็นบุคคลหรือ นิติบุคคล
        จ่ายเงินได้ให้กับบุคคลธรรมดา ต้องหักภาษี
        ออกจากค่าจ้างที่จ้างบุคคลภายนอกมาทำงานให้
      </div>
      <br />
      <span class="bold">แบบภาษีเงินได้บุคคลธรรมดา ภ.ง.ด. 90</span>
      <div>แบบแสดงรายการภาษีเงินได้บุคคลธรรมดาสำหรับผู้มีเงินได้กรณีทั่วไป</div>
      <br />
      <span class="bold">แบบภาษีเงินได้บุคคลธรรมดาครึ่งปี ภ.ง.ด. 94 </span>
      <div>
        แบบแสดงรายการภาษีเงินได้บุคคลธรรมดาครึ่งปี สำหรับผู้มีเงินได้ตามมาตรา 40
        (5) (6) (7) (8) แห่งประมวลรัษฎากร
      </div>
      <br />
      <span class="bold">แบบแสดงรายการสรุปภาษีซื้อขาย ภพ. 30 </span>
      <div>
        แบบแสดงรายการสรุปภาษีซื้อ ภาษีขาย เพื่อนำส่ง
        สรรพากรโดยผู้มีหน้าที่จัดทำคือ เจ้าของธุรกิจที่มี รายได้มากกว่า 1.8
        ล้านบาท/ ปี และได้ทำการจด ทะเบียนภาษีมูลค่าเพิ่มแล้ว
        ต้องทำส่งให้กรมสรรพากร ทุกเดือนภายในวันที่ 15 ของเดือนถัดไป
        หรือสามารถยื่นผ่านทาง อินเตอร์เน็ตได้
      </div>
    </div>
  </template-info>
</template>
<script>
import BackgroundImg from "@/assets/images/infos/documents.png";

export default {
  name: "Documents",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
